(function () {
  function getHeaderEl() {
    return (
      document.querySelector('sticky-header') ||
      document.querySelector('.header-wrapper') ||
      document.querySelector('#shopify-section-header') ||
      document.querySelector('header')
    );
  }

  // Cache last height to skip no-op style writes (avoids forced reflows downstream)
  var lastH = -1;

  function updateStickyTop() {
    var header = getHeaderEl();
    var h = header ? Math.ceil(header.getBoundingClientRect().height) : 72;

    if (h === lastH) return; // nothing changed — skip style write
    lastH = h;

    var gap = 12;
    document.documentElement.style.setProperty('--af-header-h', h + 'px');
    document.documentElement.style.setProperty('--af-sticky-top', (h + gap) + 'px');
  }

  // Initial measurement
  updateStickyTop();

  // ResizeObserver is the primary/only observer — fires when header height
  // actually changes (e.g. sticky shrink, viewport resize, font load).
  // This replaces the old resize + scroll + orientationchange listeners
  // that were each causing redundant getBoundingClientRect reflows.
  if ('ResizeObserver' in window) {
    var header = getHeaderEl();
    if (header) {
      var rafId = 0;
      new ResizeObserver(function () {
        if (rafId) return;
        rafId = requestAnimationFrame(function () {
          rafId = 0;
          updateStickyTop();
        });
      }).observe(header);
    }
  } else {
    // Fallback for very old browsers: debounced resize only
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(updateStickyTop, 120);
    }, { passive: true });
  }
})();
